import { Button, DialogActions, DialogContent, Typography } from '@mui/material'
import React from 'react'
import { setOpenModal } from '../../../ControlPanel/store/controlPanelSlice';
import { useDispatch } from 'react-redux';
import { setshowPermissionDialog } from '../../store/mediaPlaybackSlice';
import { useTranslation } from 'react-i18next';

export default function PermissionAudioDialog() {
        const dispatch = useDispatch();
        const { t } = useTranslation();
    
      const onClose = () => {
        dispatch(setOpenModal(null));
        dispatch(setshowPermissionDialog(false));
    }
  return (

    <>
       <DialogContent>
          <Typography
            gutterBottom
            style={{
              textAlign: "justify",
              fontSize: "1rem",
              whiteSpace: "pre-line"
            }}
          >
             {t("audio_permission_message")}
          </Typography>
         
        </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#77dd48",
                "&:hover": {
                  backgroundColor: "var(--peoplmap-primary)",
                },
              }}
              onClick={onClose}
            >
              d'accord
            </Button>
          </DialogActions>  
    
    </>
 

            )}
